import { PacketOut } from "./PacketOut.js";
import { OutboundPacketType } from "./OutboundPacketType.js";
import type { MessageIOContext } from "../../../api/MessageIOContext.js";


export class PacketOutReOpen extends PacketOut {
    public static readonly PROTOCOL_VERSION_KEY = "protocol_version";
    public static readonly PREVIOUS_ID_KEY = "previous_id";

    private readonly protocolVersion: number;
    private readonly previousID: string;

    constructor(protocolVersion: number, previousID: string) {
        super(OutboundPacketType.REOPEN);
        this.protocolVersion = protocolVersion;
        this.previousID = previousID;
    }

    override writeContents(_context: MessageIOContext): Record<string, any> {
        return {
            [PacketOutReOpen.PROTOCOL_VERSION_KEY]: this.protocolVersion,
            [PacketOutReOpen.PREVIOUS_ID_KEY]: this.previousID,
        };
    }
}
